var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.userPoints
    ? _c(
        "div",
        {
          staticClass: "profile-points-section",
          attrs: { id: "profile-points-section" }
        },
        [
          _c(
            "modal",
            {
              attrs: {
                name: "point-system-modal",
                height: "auto",
                scrollable: "",
                adaptive: "",
                "click-to-close": false
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "stick-top-right",
                  staticStyle: { top: "10px" }
                },
                [
                  _c("button", {
                    staticClass: "btn-close md-close vs-btn-legacy",
                    on: { click: _vm._hideModal }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "container pt-6 pb-4" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col p-0" },
                    [
                      _vm.currentModal
                        ? _c(_vm.currentModal, {
                            tag: "component",
                            on: { "go-to": _vm.goTo }
                          })
                        : _c("div", { staticClass: "p-6 text-center" }, [
                            _vm._v("\n            Loading...\n          ")
                          ])
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-column flex-grow-1",
              attrs: { id: "profile-points-level-badges-section" }
            },
            [
              _vm.isOwner
                ? _c("div", { staticClass: "d-flex flex-column" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center mr-4 mb-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "point-icon",
                            attrs: { id: "point-icon" }
                          },
                          [_vm._v("\n          P\n        ")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "mr-4 font-weight-bold" }, [
                          _vm._v(
                            _vm._s(_vm.userPoints.experiencePoints.current)
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.userPoints.level.earnMessage))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-grow-1 align-items-center mb-4",
                        attrs: { id: "progress-bar-wrapper" }
                      },
                      [
                        _c("div", { staticClass: "progress mr-4" }, [
                          _c("div", {
                            staticClass: "progress-bar",
                            style: { width: _vm.percentage + "%" },
                            attrs: {
                              role: "progressbar",
                              "aria-valuenow": _vm.percentage,
                              "aria-valuemin": "0",
                              "aria-valuemax": "100"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.userPoints.experiencePoints.current) +
                              "/" +
                              _vm._s(
                                _vm.userPoints.experiencePoints
                                  .requiredForNextLevel
                              )
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  attrs: { id: "profile-badges-section" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex", attrs: { id: "badges__bar" } },
                    [
                      _c(
                        "span",
                        { staticClass: "mb-6 mr-3 font-weight-bold" },
                        [_vm._v("Badges")]
                      ),
                      _vm._v(" "),
                      _vm.isOwner
                        ? _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm._onOpenModal("badge")
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "cursor-pointer",
                                attrs: {
                                  src: require("@/images/right-chevron.png"),
                                  width: "14",
                                  height: "14"
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isOwner
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex",
                          attrs: { id: "badges-image" }
                        },
                        _vm._l(_vm.userPoints.badges, function(badge) {
                          return _c("img", {
                            key: badge.name,
                            staticClass: "badge-image",
                            style: !badge.isUnlocked && {
                              backgroundColor: "#a9a9a9",
                              padding: "24px",
                              border: "none"
                            },
                            attrs: { src: _vm.badgeImage(badge) }
                          })
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isOwner
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex",
                          attrs: { id: "badges-image" }
                        },
                        _vm._l(_vm.user.points.badges, function(badge) {
                          return _c("img", {
                            key: badge.name,
                            staticClass: "badge-image",
                            style: !badge.isUnlocked && {
                              backgroundColor: "#a9a9a9",
                              padding: "24px",
                              border: "none"
                            },
                            attrs: { src: _vm.badgeImage(badge) }
                          })
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.isOwner
            ? _c(
                "div",
                {
                  staticClass: "d-flex mt-4",
                  attrs: { id: "profile-points-actions-section" }
                },
                _vm._l(_vm.pointActions, function(action) {
                  return _c(
                    "div",
                    {
                      key: action.label,
                      staticClass: "d-flex position-relative"
                    },
                    [
                      action.label === "Missions" && _vm.achievedMissionsCount
                        ? _c(
                            "div",
                            { staticClass: "achieved-missions-indicator" },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.achievedMissionsCount) +
                                  "\n      "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "VsButton",
                        {
                          staticClass: "profile-actions-button",
                          on: { click: action.action }
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(action.label) + "\n      "
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }